// Статусы принципов (FR-PROF-02) — те же правила, что на сервере (progress-rules в WebAssembly).
import { loadEngine, principleStatuses } from "@brovka/tactics-wasm";
import type { StoredEvent } from "./db.ts";

export type PrincipleStatus = { status: "not_started" | "introducing" | "progressing" | "mastered"; first_attempts: number; window_good: number; window_size: number };

/** События ребёнка → вход правил прогресса. */
export function toRulesEvents(events: StoredEvent[]): unknown[] {
  const out: unknown[] = [];
  for (const e of events) {
    const ms = Date.parse(e.occurredAt);
    const principles = Array.isArray(e.payload.principles) ? (e.payload.principles as string[]) : [];
    if (e.type === "quiz_answered" && typeof e.payload.attempt === "number") {
      out.push({ type: "answer", event_id: e.eventId, occurred_at_ms: ms, principles, attempt: e.payload.attempt, grade: e.payload.grade, variant: e.payload.variant });
    } else if (e.type === "home_exercise_done") {
      out.push({ type: "exercise_done", event_id: e.eventId, occurred_at_ms: ms, principles });
    }
  }
  return out;
}

export async function computeStatuses(events: StoredEvent[]): Promise<Record<string, PrincipleStatus>> {
  await loadEngine();
  return JSON.parse(principleStatuses(JSON.stringify(toRulesEvents(events)))) as Record<string, PrincipleStatus>;
}
